const stringifyHotkey = k => {
  return JSON.stringify({
    code: k.code,
    ctrl: !!k.ctrl,
    shift: !!k.shift,
    alt: !!k.alt,
    meta: !!k.meta
  });
};

/**
 *  hotkeyMap
 */
// eslint-disable-next-line @typescript-eslint/ban-types
const getHotkeyHandler = hotkeyMap => {
  const map = {};
  hotkeyMap.forEach((callback, hotkey) => {
    hotkey = typeof hotkey === 'string' ? {
      code: hotkey
    } : hotkey;
    map[stringifyHotkey(hotkey)] = callback;
  });
  return event => {
    const key = stringifyHotkey({
      code: event.key,
      ctrl: !!event.ctrlKey,
      shift: !!event.shiftKey,
      alt: !!event.altKey,
      meta: !!event.metaKey
    });
    const callback = map[key];
    if (callback) {
      event.stopPropagation();
      if (callback(event) === false) {
        event.preventDefault();
      }
    }
  };
};

export { getHotkeyHandler };
